import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }, [
      _createElementVNode("path", { d: "m32.575 16.1 4.3-4.3c2.2-2.2 2.2-5.8 0-8s-5.8-2.2-8 0l-19 19" }),
      _createElementVNode("path", { d: "m18.775 1.5-14.5 15.9c-3.7 3.7-3.7 9.8 0 13.5s9.8 3.7 13.5 0l9.1-9.1" })
    ], -1)
  ]))]))
}
export default { render: render }